var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import * as Sentry from "@sentry/react";
import { TactonAPI } from "@animech/tacton-api-base";
import { ApiError, ApiErrorType } from "api/errors";
var baseConfig = {
    params: { externalId: "ext1000", key: "mgLxVCAniMechB87Szmv" },
    productId: "m9adb04e62224f1181e1eff5d75f874b",
    tabId: "7bd80669544d48c6b947ca9ddab2d50b",
};
var _tactonAPI = new TactonAPI(__assign({}, baseConfig));
export var setTactonApiLanguage = function (language) {
    _tactonAPI = new TactonAPI(__assign(__assign({}, baseConfig), { params: __assign(__assign({}, baseConfig.params), { language: language }) }));
};
export var getImageUrl = function (imagePath, ticket) {
    return _tactonAPI.getImageUrl(imagePath, ticket);
};
export var start = function (ticket) {
    return _tactonAPI.start(ticket);
};
export var step = function (configId, stepName, ticket) { return _tactonAPI.step(configId, stepName, ticket); };
export var commit = function (configId, parameters, values, ticket) { return _tactonAPI.commit(configId, parameters, values, ticket); };
export var uncommit = function (configId, parameters, ticket) { return _tactonAPI.uncommit(configId, parameters, ticket); };
export var performRequest = TactonAPI.performRequest;
export var tactonCommonAPI = {
    startConfiguration: function (ticket) { return __awaiter(void 0, void 0, void 0, function () {
        var response, err_1, error, message;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    response = { configId: "" };
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, _tactonAPI.start(ticket)];
                case 2:
                    response = _a.sent();
                    return [3 /*break*/, 4];
                case 3:
                    err_1 = _a.sent();
                    // eslint-disable-next-line no-console
                    console.log(err_1);
                    Sentry.captureException(err_1);
                    error = err_1;
                    message = JSON.parse(error.message).message;
                    throw new ApiError(message, ApiErrorType.REQUEST_ERROR);
                case 4: return [2 /*return*/, response.configId];
            }
        });
    }); },
};
